import { useMemo, useState } from 'react';
import './CalorieCounter.css';
import FitFacts from './FitFacts';
import { clamp, handleArrowCommit, commitNumberInput, handleRangeIntChange } from './helpers.js';

const ACTIVITIES = [
	{ value: 0, label: ' - Select -->' },
	{ value: 5.0, label: 'Aerobic Dance (Casual)' },
	{ value: 6.5, label: 'Aerobic Dance (Moderate)' },
	{ value: 7.0, label: 'Aerobic Dance (Intense)' },
	{ value: 8.0, label: 'Basketball (Game)' },
	{ value: 6.0, label: 'Basketball (Non-Game, General)' },
	{ value: 4.5, label: 'Basketball (Shooting Baskets)' },
	{ value: 8.0, label: 'Calisthenics (Intense)' },
	{ value: 3.5, label: 'Calisthenics (Moderate)' },
	{ value: 4.0, label: 'Cycling (5.5 mph)' },
	{ value: 8.0, label: 'Cycling (12-13 mph)' },
	{ value: 12.0, label: 'Cycling (16-19 mph, Racing)' },
	{ value: 3.0, label: 'Dancing (Casual)' },
	{ value: 5.5, label: 'Dancing (Fast)' },
	{ value: 9.0, label: 'Football (Competitive)' },
	{ value: 8.0, label: 'Football (Flag, Touch, General)' },
	{ value: 2.5, label: 'Football (Playing Catch)' },
	{ value: 3.0, label: 'Frisbie (General)' },
	{ value: 8.0, label: 'Frisbie (Ultimate)' },
	{ value: 4.5, label: 'Golf (Carry Clubs)' },
	{ value: 3.5, label: 'Golf (with Cart)' },
	{ value: 4.0, label: 'Gymnastics' },
	{ value: 6.0, label: 'Hiking (Cross Country)' },
	{ value: 3.0, label: 'Housework' },
	{ value: 12.0, label: 'Jump Rope (Fast)' },
	{ value: 8.0, label: 'Jump Rope (Slow)' },
	{ value: 5.0, label: 'Kayaking' },
	{ value: 7.0, label: 'Kickball' },
	{ value: 1.0, label: 'Lying Quietly' },
	{ value: 10.0, label: 'Martial Arts' },
	{ value: 4.0, label: 'Motocross' },
	{ value: 7.0, label: 'Racquetball (Casual)' },
	{ value: 10.0, label: 'Racquetball (Competitive)' },
	{ value: 8.0, label: 'Rock/Mountain Climbing' },
	{ value: 11.0, label: 'Rollerblading/skating (Casual)' },
	{ value: 12.0, label: 'Rollerblading/skating (Fast)' },
	{ value: 10.5, label: 'Rowing Machine (Extreme)' },
	{ value: 7.0, label: 'Rowing Machine (Moderate)' },
	{ value: 7.0, label: 'Running (Jogging/General)' },
	{ value: 8.0, label: 'Running (5 mph, 12min mile)' },
	{ value: 10.0, label: 'Running (6 mph, 10min mile)' },
	{ value: 11.5, label: 'Running (7 mph, 8.5min mile)' },
	{ value: 13.5, label: 'Running (8 mph, 7.5min mile)' },
	{ value: 16.0, label: 'Running (10 mph, 6min mile)' },
	{ value: 9.0, label: 'Running (Cross Country)' },
	{ value: 5.0, label: 'Snow Skiing (Downhill - General)' },
	{ value: 6.0, label: 'Snow Skiing (Downhill - Moderate)' },
	{ value: 8.0, label: 'Snow Skiing (Downhill - Extreme)' },
	{ value: 7.0, label: 'Snow Skiing (Cross Country - General)' },
	{ value: 8.0, label: 'Snow Skiing (Cross Country - Moderate)' },
	{ value: 9.0, label: 'Snow Skiing (Cross Country - Brisk)' },
	{ value: 8.0, label: 'Snow Shoeing' },
	{ value: 1.5, label: 'Sitting (Office work)' },
	{ value: 1.0, label: 'Sitting (Quietly)' },
	{ value: 5.0, label: 'Skateboarding' },
	{ value: 10.0, label: 'Soccer (Competitive)' },
	{ value: 7.0, label: 'Soccer (Casual, General)' },
	{ value: 5.0, label: 'Softball' },
	{ value: 12.0, label: 'Squash' },
	{ value: 8.0, label: 'Stair/Ladder Climbing' },
	{ value: 2.3, label: 'Standing (Office work)' },
	{ value: 1.0, label: 'Standing (Quietly)' },
	{ value: 2.5, label: 'Stretching/Hatha Yoga' },
	{ value: 7.0, label: 'Swimming (Casual)' },
	{ value: 10.0, label: 'Swimming (Vigorous)' },
	{ value: 4.0, label: 'Table Tennis/Ping Pong' },
	{ value: 4.0, label: 'Tai Chi' },
	{ value: 6.0, label: 'Tennis (Doubles)' },
	{ value: 8.0, label: 'Tennis (Singles)' },
	{ value: 3.0, label: 'Volleyball (Casual Indoor/Grass)' },
	{ value: 8.0, label: 'Volleyball (Beach)' },
	{ value: 8.0, label: 'Volleyball (Competitive)' },
	{ value: 2.0, label: 'Walking (2 mph, Casual Pace)' },
	{ value: 3.3, label: 'Walking (3 mph, Moderate Pace)' },
	{ value: 3.8, label: 'Walking (3.5 mph, Brisk Pace)' },
	{ value: 5.0, label: 'Walking (4 mph, Very Brisk Pace)' },
	{ value: 9.0, label: 'Walking (5.0, Fast Pace)' },
	{ value: 10.0, label: 'Water Polo' },
	{ value: 6.0, label: 'Weight Training (Intense)' },
	{ value: 3.0, label: 'Weight Training (Normal)' },
	{ value: 5.5, label: 'Yardwork (Heavy)' },
	{ value: 4.0, label: 'Yardwork (Regular)' }
];

const convertToNiceTime = (minutes) => {
	const intMinutes = parseInt(minutes, 10);

	if (intMinutes < 59) {
		return `0:${intMinutes}`;
	}

	const hours = Math.floor(intMinutes / 60);
	const remainderMinutes = intMinutes % 60;
	return `${hours}:${remainderMinutes.toString().padStart(2, '0')}`;
};

const calculateExpenditure = (activity, timeInMinutes, weightInPounds) => {
	const duration = parseFloat(timeInMinutes) / 60;
	const weightInKg = parseFloat(weightInPounds) * 0.45359237;
	const expenditure = parseFloat(activity) * weightInKg * duration;

	return Number.isFinite(expenditure) ? parseInt(expenditure.toString(), 10) : 0;
};

export default function CalorieCounter() {
	const [weight, setWeight] = useState(169);
	const [time, setTime] = useState(90);
	const [activity, setActivity] = useState(0);
	const [weightInput, setWeightInput] = useState('169');

	const caloriesBurned = useMemo(
		() => calculateExpenditure(activity, time, weight),
		[activity, time, weight]
	);

	return (
		<div className="calc-container-scroller">
			<div className="calc-container-scroller-inner">
				<div className="spc-p-1 spc-m-b-2 bg-color-gray-light">
					<h3>Physical Activity Calorie Counter</h3>

					<div className="calculator-row">
						<div className="range-row">
							<div className="range-row__input-wrap">
								<input
									id="range-weight"
									type="range"
									min="50"
									max="300"
									value={weight}
									onChange={(e) => {
										const nextWeight = parseInt(e.target.value, 10);
										setWeight(nextWeight);
										setWeightInput(nextWeight.toString());
									}}
								/>
							</div>

							<div className="range-row__result-wrap">
								<label htmlFor="result-weight">Body Weight (lbs.): </label>
								<input
									type="number"
									id="result-weight"
									name="result-weight"
									min="50"
									max="300"
									value={weightInput}
									onChange={(e) => setWeightInput(e.target.value)}
									onKeyUp={(e) => handleArrowCommit(e, 50, 300, weight, setWeight, setWeightInput)}
									onBlur={() => commitNumberInput(weightInput, 50, 300, weight, setWeight, setWeightInput)}
								/>
							</div>
						</div>
					</div>

					<div className="calculator-row">
						<div className="range-row">
							<div className="range-row__input-wrap">
								<input
									id="range-time"
									type="range"
									min="10"
									max="240"
									step="10"
									value={time}
									onChange={(e) => handleRangeIntChange(e, setTime)}
								/>
							</div>

							<div className="range-row__result-wrap">
								<label htmlFor="result-time">Hours Spent: </label>
								<input
									type="text"
									id="result-time"
									name="result-time"
									readOnly
									value={convertToNiceTime(time)}
								/>
							</div>
						</div>
					</div>

					<div className="spc-m-b-1">
						<span>Select an Activity:</span>
						<select name="menu-activity" id="menu-activity"
							onChange={
								(e) => {
									const val = parseFloat(e.target.value);
									console.log(e.target.value, val);
									setActivity(val);
								}
							}
						>
							{ACTIVITIES.map((entry) => (
								<option key={`${entry.label}-${entry.value}`} value={entry.value}>
									{entry.label}
								</option>
							))}
						</select>
					</div>

					<hr />

					<div className="results-row">
						<h4 className="results-row__label">You burned an estimated:</h4>

						<input
							type="text"
							className="results-row__value"
							readOnly
							id="result-calories-burned"
							name="result-calories-burned"
							value={caloriesBurned}
						/>
					</div>

					<FitFacts
						items={[
							{
								label: 'Weight Loss: 10 Tips For Keeping it Off For Good!',
								link: '/images/webcontent/assets/education-resources/lifestyle/fitfacts/pdfs/fitfacts/itemid_3587.pdf'
							},
							{
								label: 'Keeping Your Weight in Check',
								link: '/images/webcontent/assets/education-resources/lifestyle/fitfacts/pdfs/fitfacts/itemid_3586.pdf'
							},
							{
								label: 'How to Start an Exercise Program',
								link: '/images/webcontent/assets/education-resources/lifestyle/fitfacts/pdfs/fitfacts/itemid_3585.pdf'
							}
						]}
					/>
				</div>
			</div>
		</div>
	);
}
